import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import atom from '@tencent/vft-atom';
import env from '@tencent/vft-common/env';
import PwdDialogBtn from "./PwdDialogBtn.vue";
import PwdDialogText from "./PwdDialogText.vue";
import PwdDialogTextWithPic from "./PwdDialogTextWithPic.vue";

function roll(arr) {
  if (!Array.isArray(arr)) {
    return arr;
  }

  if (arr.length === 1) {
    return arr[0];
  }

  return arr[Math.floor(Math.random() * arr.length)];
}

export default {
  name: 'vu-pwd-dialog',
  provide: function provide() {
    return {
      pwds: this.rolledPwds
    };
  },
  props: {
    thumbpic: {
      type: String
    },
    channel: {
      type: String,
      default: 'weixin' // weixin | wxmoments

    },
    pwds: {
      type: Array,
      require: true
    }
  },
  data: function data() {
    return {
      useInput: !env.isApp || env.isKidApp,
      isVisible: false,
      actionText: '',
      pwdText: ''
    };
  },
  computed: {
    moduleName: function moduleName() {
      return this.withPic ? '朋友圈口令弹窗' : '口令弹窗';
    },
    withPic: function withPic() {
      return this.channel === 'wxmoments';
    },
    autoClick: function autoClick() {
      return !this.withPic && this.rolledPwds.length === 1 && !env.isKidApp;
    },
    rolledPwds: function rolledPwds() {
      return this.pwds.map(function (pwd) {
        return {
          title: pwd.title,
          text: roll(pwd.text)
        };
      });
    }
  },
  created: function created() {
    this.actionText = this.withPic ? '前往微信发布朋友圈' : '前往微信粘贴给好友';
    this.pwdText = this.rolledPwds[0].text;

    if (this.autoClick) {
      this.countDown();
    }
  },
  methods: {
    show: function show() {
      this.isVisible = true;
    },
    hide: function hide() {
      var _this = this;

      this.isVisible = false;
      setTimeout(function () {
        _this.$emit('close');

        _this.remove();
      }, 300);
    },
    cancel: function cancel() {
      this.hide();
      this.$emit('cancel');
    },
    countDown: function countDown() {
      var _this2 = this;

      var count = 3;
      var id = setInterval(function () {
        if (count === 0) {
          clearInterval(id);
          _this2.actionText = '前往微信粘贴给好友';
          return;
        }

        _this2.actionText = "".concat(count--, "s\u540E\u524D\u5F80\u5FAE\u4FE1\u7C98\u8D34\u7ED9\u597D\u53CB");
      }, 1000);
      this.actionText = "".concat(count--, "s\u540E\u524D\u5F80\u5FAE\u4FE1\u7C98\u8D34\u7ED9\u597D\u53CB");
    },
    copy2Clipboard: function copy2Clipboard() {
      var _this3 = this;

      return env.isApp && !env.isKidApp ? atom.invoke('copyToClipBoard', {
        content: this.pwdText
      }).catch(function (e) {
        if (e.errCode !== '0') {
          throw e;
        }
      }) : new Promise(function (resolve, reject) {
        try {
          _this3.$refs.input.select();

          _this3.$refs.input.setSelectionRange(0, 99999);

          var successful = document.execCommand('copy');

          if (!successful) {
            throw new Error('copy failed.');
          }

          resolve();
        } catch (e) {
          reject();
        }
      });
    },
    action: function () {
      var _action = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this4 = this;

        var action;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.copy2Clipboard();

              case 3:
                _context.next = 8;
                break;

              case 5:
                _context.prev = 5;
                _context.t0 = _context["catch"](0);
                this.toast && this.toast("\u590D\u5236\u53E3\u4EE4\u5931\u8D25".concat(env.isApp ? '' : '，请尝试手动复制'));

              case 8:
                if (this.withPic) {
                  action = env.isApp ? atom.invoke('shareWeixinTimeline', {
                    imgbase64String: this.thumbpic,
                    isShareImageOnly: true
                  }) : Promise.reject();
                } else {
                  action = env.isApp ? atom.invoke('launch3rdApp', {
                    pkgName: 'com.tencent.mm',
                    pkgUrl: env.isIos ? 'weixin://' : '',
                    appName: '微信'
                  }) : new Promise(function (resolve, reject) {
                    location.href = 'weixin://';
                    reject();
                  });
                }

                action.then(function () {
                  _this4.hide();
                }, function () {
                  void 0;
                });

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 5]]);
      }));

      function action() {
        return _action.apply(this, arguments);
      }

      return action;
    }()
  },
  components: {
    PwdDialogBtn: PwdDialogBtn,
    PwdDialogText: PwdDialogText,
    PwdDialogTextWithPic: PwdDialogTextWithPic
  }
};